export default "__VITE_ASSET__DLZhF3Z___"